import React from 'react';
import HeroCarousel from '../components/HeroCarousel';
import GenreGrid from '../components/GenreGrid';
import TopMixes from '../components/TopMixes';
import LatestUploads from '../components/LatestUploads';
import { Radio, Download, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="pb-6">
      <HeroCarousel />

      {/* Record Pool CTA + Radio */}
      <section className="px-6 mt-10 grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 relative overflow-hidden rounded-2xl bg-gradient-to-r from-orange-600/20 via-rose-600/10 to-transparent border border-orange-500/20 p-6 md:p-8 flex items-center justify-between gap-4">
          <div>
            <div className="text-[11px] font-semibold tracking-wider text-orange-300 uppercase">Record Pool 2.0</div>
            <h3 className="font-display text-2xl md:text-3xl text-white mt-2">DJ Record Pool — Download Now</h3>
            <p className="text-sm text-neutral-300 mt-2 max-w-md">
              Radio edits, clean/dirty versions, intros & acapellas. Fresh drops every Friday for verified DJs.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <Link to="/record-pool" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white text-black text-sm font-semibold hover:bg-neutral-200 transition-colors">
                <Download className="w-4 h-4" /> Get Access
              </Link>
              <Link to="/submit" className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 text-white text-sm hover:bg-white/10 transition-colors">
                <Users className="w-4 h-4" /> Artists Submit
              </Link>
            </div>
          </div>
          <div className="hidden md:flex items-center justify-center">
            <div className="w-24 h-24 rounded-full bg-gradient-to-br from-orange-500 to-rose-600 flex items-center justify-center shadow-2xl shadow-orange-500/30">
              <Download className="w-10 h-10 text-white" />
            </div>
          </div>
        </div>

        <div className="rounded-2xl bg-white/[0.03] border border-white/5 p-6 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-2 text-orange-300">
              <Radio className="w-4 h-4" />
              <span className="text-[11px] font-semibold tracking-wider uppercase">GCL Connect</span>
            </div>
            <div className="mt-3 flex items-center gap-3">
              <span className="inline-flex items-end h-6">
                <span className="eq-bar" />
                <span className="eq-bar" />
                <span className="eq-bar" />
                <span className="eq-bar" />
              </span>
              <span className="text-white text-sm font-semibold">TuneIn Radio Live</span>
            </div>
            <div className="text-xs text-neutral-400 mt-2">Non-stop Gulf Coast Latin heat</div>
          </div>
          <button className="mt-4 w-full py-2.5 rounded-full bg-orange-500 hover:bg-orange-400 text-black text-sm font-semibold transition-colors">
            Listen Live
          </button>
        </div>
      </section>

      <GenreGrid />
      <TopMixes />
      <LatestUploads />
    </div>
  );
};

export default Home;
